import { getConfigForImportedTest, getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import qestIds from '../../../QestIds';

const getConfig = (_: string) => ({
  ...getConfigForMeasuredTest(
    qestIds.soilClassification.ASTM.estimated_Psd,
    'data.Preparation.AssociatedParticleSizeDistributionResults'
  ),
  ...getConfigForImportedTest(
    qestIds.psdSieveAnalysis.ASTM_C136.rev2019,
    'data.Preparation.AssociatedParticleSizeDistributionResults',
    [qestIds.psdSieveAnalysis.ASTM_D6913.rev2017]
  ),
  'data.Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.GravelPercentage': {
    format: { nearest: 1 },
  },
  'data.Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.SandPercentage': {
    format: { nearest: 1 },
  },
  'data.Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.FinesPercentage': {
    format: { nearest: 1 },
  },
  'data.Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.Cu': { format: { nearest: 0.1 } },
  'data.Preparation.AssociatedParticleSizeDistributionResults.ExternalTest.Results.Cc': { format: { nearest: 0.1 } },
  'data.Preparation.PsdResults.GravelPercentage': { format: { nearest: 1 } },
  'data.Preparation.PsdResults.SandPercentage': { format: { nearest: 1 } },
  'data.Preparation.PsdResults.FinesPercentage': { format: { nearest: 1 } },
  'data.Preparation.PsdResults.Cu': { format: { nearest: 0.1 } },
  'data.Preparation.PsdResults.Cc': { format: { nearest: 0.1 } },
  'data.Preparation.Cu': { format: { nearest: 0.1 } },
  'data.Preparation.Cc': { format: { nearest: 0.1 } },
  ...getConfigForMeasuredTest(
    qestIds.soilClassification.ASTM.estimated_Al,
    'data.MaterialClassification.AssociatedAtterbergLimitsResults'
  ),
  ...getConfigForImportedTest(
    qestIds.atterbergLimit.ASTM_D_4318.methodA_Rev2017,
    'data.MaterialClassification.AssociatedAtterbergLimitsResults',
    [qestIds.atterbergLimit.ASTM_D_4318.methodB_Rev2017]
  ),
  'data.MaterialClassification.AlResults.LiquidLimit': { format: { nearest: 1 } },
  'data.MaterialClassification.AlResults.LiquidLimitOvenDry': { format: { nearest: 1 } },
  'data.MaterialClassification.AlResults.PlasticLimit': { format: { nearest: 1 } },
  'data.MaterialClassification.AlResults.PlasticityIndex': { format: { nearest: 1 } },
});

export { getConfig };

export default {
  [qestIds.soilClassification.ASTM_D2487.rev2017]: getConfig,
};
